export default __webpack_public_path__ + "static/media/affligem_s3.53faf2d4.png";